// @Flow
import {
  GET_STAGING_RECORD_SUCCESS,
  GET_STAGING_RECORD_FAILED,
} from '../constants'

type State = {
  error: String,
  stagingRecords: Array<any>
}

const initialState = {
  stagingRecords: [],
  error: '',
}

function stagingRecordList(state: State = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case GET_STAGING_RECORD_SUCCESS:
      return {
        ...state,
        stagingRecords: action.payload
      }
    case GET_STAGING_RECORD_FAILED:
      return {
        ...state,
        stagingRecords: [],
        error: action.payload
      }
    default:
      return state
  }
}

export default stagingRecordList



// WEBPACK FOOTER //
// ./src/modules/stagingRecordList.js